import $ from 'jquery';
import {scrollWithOffset} from '../base/utils';

class Webform {
    constructor(form) {
        let $form = $(form),
            $formWrap = $form.closest('.webform-wrap');

        this.$body = $('body');
        this.$window = $(window);
        this.$webformWrap = $form.closest('[id^="webform"]');

        this.type = $formWrap.data('type');
        this.isSingle = $formWrap.data('single') === true;
        this.isLayer = $formWrap.closest('.layer').length > 0;

        if (this.isSingle && this.isSubmitted()) {
            alert('hide-form');
            this.hideForm($form);
        } else {
            this.events();
        }
    }

    isSubmitted() {
        try {
            let submitted = JSON.parse(localStorage.getItem('submitted-ids'));

            return submitted.indexOf(this.$webformWrap.find('.webform-wrap').data('form-id')) >= 0;
        } catch (e) {

        }
    }

    hideForm($form) {
        $form.closest('.webform-wrap').addClass('thank-you');
    }

    setSubmitted(id) {
        if (id) {
            try {
                let storage = localStorage.getItem('submitted-ids'),
                    submitted = storage ? JSON.parse(storage) : [];

                submitted.push(id);

                localStorage.setItem('submitted-ids', JSON.stringify(submitted));
            } catch (e) {

            }
        }
    }

    trackContact(formId, data) {
        let source = this.$webformWrap.find('[name="track_source"]').val();

        data.event = 'GAevent';
        data.eventLabel = source;
        data.formID = formId;

        window.dataLayer.push(data);
    }

    trackNewsletter(formId, data) {
        let source = this.$webformWrap.find('[name="track_source"]').val();

        data.event = 'GAevent';

        if (source && source.length > 0) {
            data.eventLabel = source;
        }


        window.dataLayer.push(data);
    }

    trackNewsletterProtected(formId, data) {
        let $newsletter = this.$webformWrap.find('[name="newsletter"]:checked');

        data.event = 'GAevent';
        data.eventLabel = $newsletter.length ? $newsletter.val() : '0';


        window.dataLayer.push(data);
    }

    track(formId, formdata) {
        try {
            let data = JSON.parse(formdata);

            switch (this.type) {
                case 'newsletter':
                    this.trackNewsletter(formId, data);
                    break;
                case 'newsletter-protected':
                    this.trackNewsletterProtected(formId, data);
                    break;
                case 'contact':
                    this.trackContact(formId, data);
                    break;
                default:
            }
        } catch (e) {
            console.error(e, 'malformed json', formdata);
        }
    }

    focusOnError() {
        let $errorField = this.$webformWrap.find('.error').first();
        if ($errorField.length) {
            let $layer = $errorField.closest('.layer'),
                container = $layer.length ? $layer[0] : null,
                offset = $layer.length ? null : document.getElementById('top-bar');

            scrollWithOffset($errorField[0], container, offset);
        }
    }

    events() {
        this.$webformWrap
            .on('change', `input, select, textarea`, e => {
                let $form = this.$webformWrap.find('.webform'),
                    $input = $(e.target),
                    $field = $input.closest('.field, .checkbox'),
                    isFilled = $input.is(':checked') || $input.val() !== '';

                $field.toggleClass('error', !isFilled);

                if ($field.hasClass('conditionally-required') && isFilled) {
                    $form.find('.conditionally-required').removeClass('error');
                }
            })
            .on('submit', 'form', e => {
                e.preventDefault();

                let $form = this.$webformWrap.find('.webform'),
                    lang = $('html').attr('lang');

                $form.addClass('form-loading');

                $.post($form.attr('action'), $form.serialize())
                    .done(data => {
                        if (data) {
                            for (let i in data) {
                                let row = data[i];

                                if (row.command === 'insert' && row.method === 'html' && this.$webformWrap.is(row.selector)) {
                                    let $formData = $(row.data),
                                        isSuccess = $formData.find('form.thank-you').length !== 0 || $formData.filter('form.thank-you').length !== 0,
                                        $thankyouContent = $formData.find('.thank-you-content.non-empty'),
                                        $formWrap = $form.closest('.webform-wrap');

                                    if (isSuccess) {
                                        let $thankyou = $formWrap.find('.thank-you-content');

                                        this.$webformWrap.find('.global-errors').html('');
                                        if ($thankyouContent.length) {
                                            this.$webformWrap.find('.thank-you-content').html($thankyouContent.html());
                                        }
                                        this.hideForm($form);
                                        this.setSubmitted($formData.data('form-id'));

                                        // wysrodkuj thank-you na stronie
                                        if (this.isLayer) {
                                            $thankyou.closest('.layer')[0].scrollTo({top: 0, left: 0, behavior: 'smooth'});
                                        } else {
                                            $('html, body').animate(
                                                {scrollTop: $thankyou.offset().top - ($(window).outerHeight() - $thankyou.outerHeight()) / 2},
                                                200);
                                        }

                                        this.track($formWrap.find('[data-submission-id]').data('submission-id'), $formWrap.find('[name=analytics]').val());
                                    } else {
                                        this.$webformWrap.html(row.data);
                                        this.$webformWrap.find('.webform').trigger('form-reload');
                                        this.focusOnError();
                                    }
                                }
                            }
                        }

                        $form.removeClass('form-loading');
                    })
                    .fail(() => {
                        $form.find('.global-errors').html('<div class="error-message">Wystąpił błąd</div>');

                        $form.removeClass('form-loading');
                    });
            });

        this.$body.on('layer-closed', (e, layer) => {
            let $layer = $(layer),
                $form = $layer.find('.webform');

            if ($form.length) {
                $form.find('.form-content input[type="text"], .form-content input[type="tel"], .form-content input[type="email"], .form-content textarea').val('');
                $form.find('.form-content input[type="checkbox"]:checked').prop('checked', false);
                $form.find('.field').removeClass('error');

                $layer.find('.webform-wrap').removeClass('thank-you');
            }
        });
    }
}

export default Webform;



// WEBPACK FOOTER //
// ./sources/js/components/webform.js